import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';
import Services from './service';
import Progress from './progress';
import Choose from './choose';
import Product1 from "../../assets/images/Product/product1.jpg";
import Product2 from "../../assets/images/Product/product2.jpg";
import Product3 from "../../assets/images/Product/product3.jpg";
import Product4 from "../../assets/images/Product/product4.jpg";
import Producticon1 from "../../assets/images/Product/product-icon1.png";
import Producticon2 from "../../assets/images/Product/product-icon2.png";
import Producticon3 from "../../assets/images/Product/product-icon3.png";
import Producticon4 from "../../assets/images/Product/product-icon4.png";
import Pattern from "../../assets/images/Product/pattern-9.png";
import './product.css';
import Example from './Attendance/example';
import Productsec from "./product1";
import SEO from "../seo";

export default function Odoo() {
         const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
             <SEO
                title="Products"
                description="At HWPL! we recognize that privacy is important. This Privacy Policy applies to all products and services provided by us. Collection Of Information Disclaimer: Please read and edit the Privacy Policy given below as per your /website’s requirement. Don’t use or apply these as is basis on your website. We collect various information when you [&hellip;]"
                canonical="https://www.hwplindia.com/products/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Products</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Products</li>
                    </ul>
                </div>
            </section>

            {/* <section className="business-section" style={{ backgroundImage: `url(${Pattern})` }}>
                <div className="auto-container">
                    <div className="sec-title-two centered">
                        <div className="sec-title_title">Our Company Products</div>
                        <h2 className="sec-title_heading">
                            Our Products will solve business problems
                        </h2>
                    </div>

                    <div className="business-grid">

                        <div className="business-card">
                            <div className="card-image">
                                <img src={Product1} alt="" />
                                <div className="product-icon">
                                    <img src={Producticon1} alt="" />
                                </div>
                            </div>

                            <div className="title-wrapper">
                                <div className="line"></div>
                                <h3 className="card-title">Attendance System</h3>
                                <div className="line"></div>
                            </div>

                            <p className="card-text">
                               Revolutionize your HR operations with a secure and intelligent attendance system.
                            </p>

                            <Link to='/products/attendance-system' className=''><button className="quote-btn tech-btn">Read More →</button></Link>
                        </div>

                        <div className="business-card">
                            <div className="card-image">
                                <img src={Product2} alt="" />
                                <div className="product-icon">
                                    <img src={Producticon2} alt="" />
                                </div>
                            </div>

                            <div className="title-wrapper">
                                <div className="line"></div>
                                <h3 className="card-title">Lead Management</h3>
                                <div className="line"></div>
                            </div>

                            <p className="card-text">
                               Convert more leads into customers with a centralized, automated lead management platform.
                            </p>

                            <Link to='/products/lead-management'><button className="quote-btn tech-btn">Read More →</button></Link>
                        </div>

                        <div className="business-card">
                            <div className="card-image">
                                <img src={Product3} alt="" />
                                <div className="product-icon">
                                    <img src={Producticon3} alt="" />
                                </div>
                            </div>

                            <div className="title-wrapper">
                                <div className="line"></div>
                                <h3 className="card-title">Odoo Services</h3>
                                <div className="line"></div>
                            </div>

                            <p className="card-text">
                                A complete solution for businesses that deal with sales, purchases, inventory, and accounts.
                            </p>

                            <Link to='/products/oddo-services'><button className="quote-btn tech-btn">Read More →</button></Link>
                        </div>

                        <div className="business-card">
                            <div className="card-image">
                                <img src={Product4} alt="" />
                                <div className="product-icon">
                                    <img src={Producticon4} alt="" />
                                </div>
                            </div>

                            <div className="title-wrapper">
                                <div className="line"></div>
                                <h3 className="card-title">Sales & Accounting</h3>
                                <div className="line"></div>
                            </div>

                            <p className="card-text">
                                As an official Odoo development partner, we offer complete ERP solutions customized to your business.
                            </p>

                            <Link to='/products/sales-accounting'><button className="quote-btn tech-btn">Read More →</button></Link>
                        </div>

                    </div>
                </div>
            </section> */}
            <Productsec/>
              <Progress/>
              <Choose/>
        </div>
    );
}